import * as actionTypes from 'constants/ActionTypes';

export function selectPreference(data) {
    return {
        type: actionTypes.SELECT_PREFERENCE,
        data,
    };
}

export function changePreference(data) {
    return {
        type: actionTypes.CHANGE_PREFERENCE,
        data,
    };
}

export function clearSelectPreference() {
    return {
        type: actionTypes.CLEAR_SELECT_PREFERENCE,
    };
}

export function getPreferences(data) {
    return {
        type: actionTypes.GET_PREFERENCES.REQUEST,
        data,
    };
}

export function getPreference(data) {
    return {
        type: actionTypes.GET_PREFERENCE.REQUEST,
        data,
    };
}

export function deletePreference(data) {
    return {
        type: actionTypes.DELETE_PREFERENCE.REQUEST,
        data,
    };
}

export function updatePreference(data, _id) {
    return {
        type: actionTypes.UPDATE_PREFERENCE.REQUEST,
        data,
        _id,
    };
}

export function updatePreferenceMeta(data) {
    return {
        type: actionTypes.UPDATE_PREFERENCE_META.REQUEST,
        data,
    };
}


// WEBPACK FOOTER //
// ./app/actions/preferences/index.js